import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    OnInit,
    ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { ModalComponent } from "@toro/common/shared/components/modal/modal.component";
import { ActionEventsEnum } from "@toro/common/shared/enum/tracking/action-events.enum";
import { TrackingActions } from "@toro/common/shared/state-management/tracking/tracking.action";
import { filter } from "rxjs/operators";
import { TraderInfoAction } from '@hub-workspace/apps/logged-home/src/app/state-management/trader/trader.action';
import { TraderInfoState } from '@hub-workspace/apps/logged-home/src/app/state-management/trader/trader.reducer';
import Player from "@vimeo/player";
import { environment } from "@hub-workspace/apps/logged-home/src/environments/environment";

@Component({
    selector: "home-trader-tips",
    templateUrl: "./home-trader-tips.component.html",
    styleUrls: ["./home-trader-tips.component.scss"],
})
export class HomeTraderTipsComponent implements AfterViewInit, OnInit {
    @ViewChild("connectChatModal", { static: true })
    public modalConnectChat: ModalComponent;
    @ViewChild("youtubeframe", { static: false })
    public youtubeFrame: ElementRef<HTMLIFrameElement>;

    public trader: TraderInfoState;
    public minimumOperationToUnlockCard: number = 20;
    public innerWidth: number;
    public isNewBrand: boolean = environment.isNewBrand

    constructor(private store: Store<any>, private router: Router) {
        this.store.dispatch({ type: TraderInfoAction.traderInfo });
    }

    ngOnInit() {
        this.getTraderInfo();
        this.innerWidth = window.innerWidth;
    }

    ngAfterViewInit() {
        this.trackConnectChatVideoPlay();
    }

    @HostListener('window:resize', ['$event'])
    public onResize(event) {
        this.innerWidth = window.innerWidth;
    }

    public getTraderInfo() {
        this.store
            .select((store) => store.trader)
            .pipe(filter((trader) => trader && !trader.pending))
            .subscribe((trader) => {
                this.trader = trader;
            });
    }

    public verifyTraderAdvisorRules() {
        return (
            this.trader &&
            this.trader.contractCurrentMonth >=
                this.minimumOperationToUnlockCard
        );
    }

    public navigateTo(path: string, element) {
        this.sendTracking("Element Clicked", {
            "Product Area Origin": "Home Trader",
            "Time Responsável": "Brooklyn Dumbo",
            Element: element,
        });
        this.router.navigate([path]);
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public openConnectChatModal() {
        this.sendTracking(ActionEventsEnum.MODAL_OPENED, {
            "Product Area Origin": "Home Trader",
            Scenario: "Connect Chat",
            "Time Responsável": "Sky",
        });
        this.modalConnectChat.show();
    }

    public closeConnectChatModal() {
        this.modalConnectChat.hide();
    }

    public trackConnectChatVideoPlay() {
        if (this.youtubeFrame.nativeElement) {
            const player = new Player(this.youtubeFrame.nativeElement);
            player.on("play", () => {
                this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
                    "Product Area Origin": "Home Trader",
                    Element: "Video Connect Chat",
                    Group: "Modal Connect Chat",
                    "Time Responsável": "Sky",
                });
            });
        }
    }
}
